import { selectFromVisitDto } from '../../models';

export default selectFromVisitDto()
  .id
  .name
  .customerId
  .customerFilledFields
  .uuid
  .eventUuid
  .phone
  .email
  .load
  .email
  .duration
  .isPriority
  .instructions
  .deliveryDate
  .customFields
  .lockedActionUuid
  .isCompleted
  .isScheduled
  .routificOrderNumber
  .customerOrderNumber
  .externalId
  .creationSource
  .pendingTargetRouteUuid
  .isDateMismatched
  .tags(tag => tag.uuid.name)
  .attempts((attempt) => attempt
    .orderUuid
    .eventUuid
    .status
    .reason
    .notes
    .date
    .latitude
    .longitude
    .distanceFromOrder
    .signature(signature => signature.base64Png.name)
    .photos(photo => photo.url.thumbnail.firebaseStorageUuid)
    .scannedPackages(pkg => pkg.uuid.scannedTime.barcode))
  .rating(rating => rating.rate.comment)
  .scheduledEvent(evnt => evnt
    .route(route => route
      .id
      .uuid
      .startDate
      .name
      .hexColor,
    ))
  .locations(location => location.id.address.originalAddress.latitude.longitude.bestMatch.active.coordinatesSource)
  .timeWindows(timeWindow => timeWindow.id.startTime.endTime)
  .packages(pkg => pkg.uuid.barcode)
  .toString();
